/**
 * Types for Matching prompt form
 */

import type { UploadedDocument } from '../types';

export type { UploadedDocument };

export type MatchingMediaType = 'none' | 'passage' | 'image' | 'audio';

export type MatchingSourceType = 'topic' | 'document';

export interface MatchingFormState {
    media: MatchingMediaType;
    // WHY: Agent matching settings are num_left / num_right — not Hub num_pairs.
    // No ticket on main; SSOT GEN_QUESTION_CONTRACT + agents/01_hub_fe.md.
    num_left: number;
    num_right: number;
    sourceType: MatchingSourceType;
    description: string;
    documents: UploadedDocument[];
}

export const MEDIA_OPTIONS: { value: MatchingMediaType; label: string }[] = [
    { value: 'none', label: 'None' },
    { value: 'passage', label: 'Passage' },
    { value: 'image', label: 'Image' },
    { value: 'audio', label: 'Audio' },
];

// WHY: Bounds mirror Agent MatchingQuestionTypeConfig (ge/le + defaults).
// SSOT GEN_QUESTION_CONTRACT §3.2 — FE must not send values Agent rejects.
export const MIN_NUM_LEFT = 2;
export const MAX_NUM_LEFT = 10;
export const MIN_NUM_RIGHT = 2;
export const MAX_NUM_RIGHT = 12;

// Default num_right = num_left + 2 per agents/01_hub_fe.md (Agent defaults 4/6).
export const DEFAULT_FORM_STATE: MatchingFormState = {
    media: 'none',
    num_left: 4,
    num_right: 6,
    sourceType: 'topic',
    description: '',
    documents: [],
};

export const DOCUMENT_ACCEPT = '.pdf,.txt,.doc,.docx,.rtf';
